import TitleUpdater from '../../../../../utils/TitleUpdater';
import StaffAugmentationHero from './StaffAugmentationHero';
import StaffingModels from './StaffingModels';
import StaffingOfferings from './StaffingOfferings';
import StaffingPositions from './StaffingPositions';
import StaffingApproach from './StaffingApproach';
import StaffingFaqs from './StaffingFaqs';

export default function StaffAugmentationManagedServices() {
  return (<main className="font-['Be_Vietnam_Pro'] bg-white" style={{ color: '#262923' }}>
    <TitleUpdater title="Staff Augmentation & Managed Services" />
    <StaffAugmentationHero />
    <StaffingModels />
    <StaffingOfferings />
    <StaffingPositions />
    <StaffingApproach />

    <StaffingFaqs />
  </main>);
}
